module.exports = __webpack_public_path__ + "img/card2.d7e48f81.png";